import { LocalStorageTTL } from '@water-web/view';

import { KEY, TTL } from './const';

export const TokenStorage = new LocalStorageTTL<string>({ key: KEY, ttl: TTL });
